export const confirmPhoneChangeRoutes = {
  CONFIRM_PHONE: "/user/phone", // POST (новый API)
};
